import type { FieldPath, FieldValues, UseFormSetError } from 'react-hook-form';
import { ApiError } from '@/lib/api/api-error';

export function applyServerErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
): void {
  if (!(error instanceof ApiError)) return;
  for (const [path, message] of Object.entries(error.fieldErrors)) {
    setError((path || 'root.server') as FieldPath<T>, { type: 'server', message });
  }
}
